export enum SegmentTrackingEventName {
  // General
  DailyStatistics = 'Daily Statistics',
  RegistrationEvent = 'Registration event',
  PriorityRegistrationEvent = 'Priority Registrations',
  SendKamPush = 'Send KAM Push',
  // Invites Flow
  InviteDelivered = 'Invite Delivered',
  InviteOpened = 'Invite Opened',
  InviteClicked = 'Invite Clicked',
  // Suggestion Modal
  SuggestionsModalViewed = 'suggestions_modal_viewed',
  SuggestionsModalSkipped = 'suggestions_modal_skipped',
  SuggestionsModalBlockedByLimit = 'suggestions_modal_blocked_by_limit',
  SuggestionsModalBlockedByMatch = 'suggestions_modal_blocked_by_match',
  // Invite Modal (variant only)
  InviteModalShown = 'invite_modal_shown',
  InviteModalConfirmed = 'invite_modal_confirmed',
  InviteModalDismissed = 'invite_modal_dismissed',
  // Hiring Flow
  JobPositionApplied = 'job_position_applied',
  OfferAccepted = 'offer_accepted',
  OfferDeclined = 'Offer Declined',
  ReasonSelected = 'Reason Selected',
  TransferredMatch = 'transferred_match',
  HiredMatch = 'hired_match',
  CandidateHired = 'candidate_hired',
  // Magazin Engagement Modal
  EngagementModalOpened = 'engagement_modal_opened',
  EngagementModalClosed = 'engagement_modal_closed',
  EngagementModalCtaClicked = 'engagement_modal_cta_clicked',
  UserLoggedIn = 'User Logged In',
  PasswordChangeRequested = 'Password Change Requested',
  PasswordForgotten = 'password_forgotten',
  PasswordSetupCompleted = 'password_setup_completed',
  PasswordStepSkipped = 'password_step_skipped',
}
